<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title"> 휴/복직신청 </v-col>
    </v-row>

    <div class="overflow-y-auto" :style="scrollViewStyle">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in list" :key="i" class="gntType-item">
            <v-list-item-content @click="selectMenu(item)">
              <!-- 대체휴가 -->
              <v-list-item-title>
                <span class="time"
                  >{{ item.codeNm }}&nbsp;&nbsp;&nbsp;{{ item.famInfo }}</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
/* 신청서 결재선공통 (결재레벨 / 결재자 / 참조자) */
import routerNames from '@/const/routerConstants';
import { getLeaAbsAppDetTgtInfoList } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    list: [],
  }),

  computed: {
    ...mapGetters(['GET_APPL_CD']),

    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    /* 신청서 선택 */
    selectMenu(item) {
      this.$store.commit('SET_CODE1', item.code);
      this.$store.commit('SET_CODE_NM', item.codeNm);
      this.$store.commit('SET_BIRTHDAY', item.famYmd);
      this.$store.commit('SET_FAM_SEQ', item.famSeq);
      this.$store.commit('SET_PER_DAY', item.famPerDay);
      this.$store.commit('SET_ADD_LIMIT_TERM', item.addLimitTerm);
      // 20240806 출산 전일때 나이를 모를수도 있음
      // 20240808 다시 8세로 변경
      if(this.GET_APPL_CD === '151' && item.famAge > 8) {
      alert('육아휴직은 8세 이하만 신청이 가능합니다');
        return;
      }

      // eslint-disable-next-line no-unreachable
      this.$router.push(routerNames.StartDateAppl);
    },
  },

  async mounted() {
    let params = {
      pApplYmd: dayjs().format('YYYYMMDD'),
      applCd: this.GET_APPL_CD,
    };

    let response = await getLeaAbsAppDetTgtInfoList(params);
    this.list = response.data.data;

    if (this.list.length === 0) {
      alert('대상자가 없습니다');
      this.$router.go(-1);
    }
  },
};
</script>

<style></style>
